import React, { useState, useEffect } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { ActualizarPersona } from "./modalActualizarPersona";
import axios from "axios";
import { Loader, Dimmer } from "semantic-ui-react";
import { Mensaje } from "../mensajes";

const headCells = [
  {
    id: "1",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "CÉDULA",
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "NOMBRES",
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "APELLIDOS",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

function TablaPersonas() {
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [titulo1, setTitulo1] = useState();
  const [msg1, setMsg1] = useState();
  const [mostrar5, setMostrar5] = useState(false);
  const [contar, setContar] = useState(0);
  const [contar1, setContar1] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [contar3, setContar3] = useState(0);
  const [contar4, setContar4] = useState(0);
  const [contar5, setContar5] = useState(0);
  const [contarRet, setContarRet] = useState(0);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [usuarioH, setUsuarioH] = useState();
  const [persona, setPersona] = useState();
  const [organizacion, setOrganizacion] = useState();
  const [configCome, setConfigCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [pagow, setPagow] = useState();
  const [retencion, setRetencion] = useState();
  const [espiritu, setEspiritu] = useState(sessionStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    sessionStorage.getItem("fechasistema")
  );
  const [anioActu, setAnioActu] = useState(sessionStorage.getItem("anioactu"));
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [permiso, setPermiso] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.cedula.includes(target.value) ||
              x.nombres.toUpperCase().includes(target.value.toUpperCase()) ||
              x.apellidos.toUpperCase().includes(target.value.toUpperCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  useEffect(() => {
    let obj = JSON.parse(sessionStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    seleccionarPersonas();
  }, []);

  const cerrarModalActualizar = () => {
    setPersona();
    setActivate(false);
    setMostrar5(false);
  };

  const renderizar = () => {
    seleccionarPersonas();
  };

  const seleccionarPersonas = () => {
    setActivate(true);
    let campos =
      "cedula, trim(nombres) AS nombres, trim(apellidos) AS apellidos";
    let nomtab = "persona";
    let orden = "cedula";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            setContar4(contar4 + 1);
            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto:
            error.response === undefined
              ? "Error de Conexion"
              : error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectPersona = (cedula) => {
    let endpoint = `${op.conexion}/api/personas/selectpersona/${cedula}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.cedula >= 0) {
            setPersona({
              cedula: response.data.cedula,
              nombres: response.data.nombres && response.data.nombres.trim(),
              apellidos:
                response.data.apellidos && response.data.apellidos.trim(),
              correoe: response.data.correoe && response.data.correoe.trim(),
              tlf1: response.data.tlf1 && response.data.tlf1.trim(),
              tlf2: response.data.tlf2 && response.data.tlf2.trim(),
              fnacimiento: response.data.fnacimiento,
              nacionalidad: response.data.nacionalidad,
              sexo: response.data.sexo,
              direccion:
                response.data.direccion && response.data.direccion.trim(),
            });
            setMostrar5(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "error al cargar el usuario",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto:
            error.response === undefined
              ? "Error de Conexion"
              : error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const agregarPersona = () => {
    setOperacion(1);
    setPersona();
    setDeshabilitado(false);
    setMostrar5(true);
  };

  const validarActuPersona = () => {
    if (operacion === 4) {
      setMostrar5(false);
      return;
    }
    setMostrar5(false);
    renderizar();
  };

  const gestionarPersona = (id, ope) => (event) => {
    event.preventDefault();
    setOperacion(ope);
    if (ope === 2) {
      setDeshabilitado(false);
    } else if (ope === 3 || ope === 4) {
      setDeshabilitado(true);
    }
    setActivate(true);
    SelectPersona(id);
  };

  return (
    <div className="container-fluid rounded">
      <div className="container-fluid">
        <div className="card">
          <ActualizarPersona
            show={mostrar5}
            titulo={titulo1}
            mensaje={msg1}
            onHideCancela={cerrarModalActualizar}
            onHideAcepta={validarActuPersona}
            persona={persona}
            deshabilitado={deshabilitado ? deshabilitado : undefined}
            operacion={operacion}
          />
          <Dimmer active={activate} inverted>
            <Loader inverted>cargando...</Loader>
          </Dimmer>

          <div className="container">
            <div className="content">
              <div className="container">
                <div className="col-md-12 row m-0 py-2">
                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control form-control-sm rounded-pill"
                      onChange={handleSearch}
                      placeholder="Buscar"
                    />
                  </div>

                  <div className="col-md-1 ml-auto">
                    <button
                      onClick={agregarPersona}
                      disabled={permiso && permiso.substring(1, 2) !== "1"}
                      className="btn btn-sm btn-primary rounded-circle"
                    >
                      <i className="fas fa-plus"></i>{" "}
                    </button>
                  </div>
                </div>
                <div className="col-md-12">
                  <TblContainer>
                    <TblHead />

                    <TableBody>
                      {records &&
                        recordsAfterPagingAndSorting().map((item, index) => (
                          <TableRow key={index} style={{ padding: "0" }}>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "center", width: "50px" }}
                            >
                              {item.cedula}
                            </TableCell>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "left", width: "250px" }}
                            >
                              {item.nombres}
                            </TableCell>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "left", width: "250px" }}
                            >
                              {item.apellidos}
                            </TableCell>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "center", width: "100px" }}
                            >
                              <button
                                onClick={gestionarPersona(item.cedula, 4)}
                                className="btn btn-sm  btn-info rounded-circle ml-2"
                              >
                                <i className="fas fa-eye"></i>{" "}
                              </button>
                              <button
                                onClick={gestionarPersona(item.cedula, 2)}
                                className="btn btn-sm  btn-warning rounded-circle ml-2"
                              >
                                <i className="fa fa-edit"></i>{" "}
                              </button>
                              <button
                                onClick={gestionarPersona(item.cedula, 3)}
                                className="btn btn-sm  btn-danger rounded-circle ml-2"
                              >
                                <i className="fa fa-trash"></i>{" "}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </div>
              </div>
            </div>
          </div>
          <Mensaje
            mensaje={mensaje}
            onHide={() => {
              setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default TablaPersonas;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaPersonas.js